/**
 * Smoothly scrolls to a section by its DOM id.
 * @param {string} id - The element id to scroll to
 */
export const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};
